<div echarts [options]="chartOptions()" class="deviation-plot-chart"></div>
